import { z } from 'zod';

/** `data` of `GET /api/v1/exchange-rate/rate` — a single `{ date, base, quote, rate }`. */
const ExchangeRateDataSchema = z.object({
  date: z.string().nullish(),
  base: z.string().nullish(),
  quote: z.string().nullish(),
  rate: z.number().nullish(),
});

/** Envelope: `{ status, message, data }`. `data` is nullish-tolerant. */
export const ExchangeRateResponseSchema = z.object({
  status: z.boolean().optional(),
  message: z.string().optional(),
  data: ExchangeRateDataSchema.nullish(),
});

export type ExchangeRateData = z.infer<typeof ExchangeRateDataSchema>;
